import React, { Component, ReactElement } from 'react'
import { Route } from '../Annotation/Route'
import { RouteID } from '../Components/Molecules/Header/Types/Types'
import { RouteGuard } from '../Guards/RouteGuard'
import { LanguageContextProvider, MessageContextProvider } from '../../React/Common/Contexts'
import { WelcomeContainer } from '../Components/Organisms/WelcomeContainer/WelcomeContainer'
import { WebexAuth } from '../Components/Molecules/WebexAuth/WebexAuth'

@Route(RouteID.WEBEX_AUTH)
export class WebexAuthPage extends Component {
    render(): ReactElement {
        return (
            <RouteGuard route={RouteID.WEBEX_AUTH}>
                <div className='teams-auth-container'>
                    <MessageContextProvider>
                        <LanguageContextProvider>
                            <WelcomeContainer showSubtitle={false}>
                                <WebexAuth />
                            </WelcomeContainer>
                        </LanguageContextProvider>
                    </MessageContextProvider>
                </div>
            </RouteGuard>
        )
    }
}
